<template>
    <div class="col-sm-12" :class="grid ? 'col-md-' + grid : 'col-md-12'">
        <div class="form-group mb-2">
            <label class="d-block font-weight-bold">
                {{ label }}
                <span v-if="required" class="text-danger">*</span>
            </label>
            <v-date-picker
                :masks="
                    masks
                        ? masks
                        : {
                              input: 'DD/MM/YYYY',
                              data: ['DD/MM/YYYY'],
                          }
                "
                :max-date="maxDate"
                :min-date="minDate"
                :mode="mode"
                class="col-12 px-0 inline-block h-full"
                v-model="item"
                v-on:input="$emit('input', item)"
                :is-required="required"
                is24hr
                is-range
                locale="pt-BR"
                :timezone="'UTC'"
                :model-config="modelConfig"
            >
                <template v-slot="{ inputValue, inputEvents, isDragging }">
                    <div
                        class="flex flex-col sm:flex-row justify-start items-center"
                    >
                        <div class="relative flex-grow">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <button
                                        class="btn px-2 btn-sm btn-light border"
                                        type="button"
                                        @click="
                                            $emit('submit');
                                            togglePopover();
                                        "
                                        :disabled="disabled"
                                    >
                                        <i
                                            class="mdi mdi-18px"
                                            :class="
                                                mode == 'time'
                                                    ? 'mdi-clock-time-three-outline'
                                                    : 'mdi-calendar-today'
                                            "
                                        ></i>
                                    </button>
                                </div>
                                <input
                                    class="form-control"
                                    :class="
                                        isDragging
                                            ? 'text-gray-600'
                                            : 'text-gray-900'
                                    "
                                    :value="inputValue.start"
                                    v-on="inputEvents.start"
                                />
                            </div>
                        </div>
                        <div class="relative flex-grow">
                            <div class="input-group mt-3">
                                <div class="input-group-prepend">
                                    <button
                                        class="btn px-2 btn-sm btn-light border"
                                        type="button"
                                        @click="
                                            $emit('submit');
                                            togglePopover();
                                        "
                                        :disabled="disabled"
                                    >
                                        <i
                                            class="mdi mdi-18px"
                                            :class="
                                                mode == 'time'
                                                    ? 'mdi-clock-time-three-outline'
                                                    : 'mdi-calendar'
                                            "
                                        ></i>
                                    </button>
                                </div>
                                <input
                                    class="form-control"
                                    :class="
                                        isDragging
                                            ? 'text-gray-600'
                                            : 'text-gray-900'
                                    "
                                    :value="inputValue.end"
                                    v-on="inputEvents.end"
                                    :required="required"
                                />
                            </div>
                        </div>
                    </div>
                </template>
            </v-date-picker>
        </div>
    </div>
</template>
<script>
/*Mode
    - dateTime
    - time
*/
export default {
    props: [
        "maxDate",
        "minDate",
        "type",
        "value",
        "label",
        "required",
        "grid",
        "readonly",
        "disabled",
        "placeholder",
        "mt",
        "iconBtn",
        "btnText",
        "masks",
        "mode",
    ],
    data() {
        return {
            item: null,
            modelConfig: {
                type: "string",
                mask: "YYYY-MM-DD", // Uses 'iso' if missing
            },
        };
    },
    beforeMount() {
        this.item = this.value;
    },
    watch: {
        value(n, o) {
            this.item = n;
        },
    },
};
</script>
<style lang="css">
input.form-control.calendar {
    background-color: #ffffff !important;
}
.input-group .btn {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
.border-secondary {
    border: 1px solid #e9eaec !important;
}
.btn-light,
.btn-light:focus {
    color: #333333;
    background-color: #ffffff !important;
    border: 1px solid #e4e5e7 !important;
    border-right: 0 !important;
}
.vc-date-time .vc-date {
    display: none !important;
}
input.form-control.calendar:disabled {
    background: #f4f4f5 !important;
}
</style>
